export default __webpack_public_path__ + "static/media/closet1-1920w.04759e46.png";